import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { SortDirection, cycleDirection } from "@lantern/app/models";

@Component({
  selector: "ta-sort-icon",
  templateUrl: "./sort-icon.template.html"
})
export class SortIconComponent implements OnInit {
  @Input()
  get sortDirection(): SortDirection {
    return this._sortDirection;
  }
  set sortDirection(value: SortDirection) {
    if (this._sortDirection === value) {
      return;
    }

    this._sortDirection = value;

    this.emitSortDirectionChange();
  }
  private _sortDirection: SortDirection = SortDirection.NONE;

  @Output()
  sortDirectionChange = new EventEmitter<SortDirection>();

  hovered: boolean = false;

  get upSelected(): boolean {
    return this._sortDirection === SortDirection.ASCENDING;
  }

  get downSelected(): boolean {
    return this._sortDirection === SortDirection.DESCENDING;
  }

  ngOnInit(): void {
    this.canEmit = true;
  }
  private canEmit: boolean = false;

  private emitSortDirectionChange(): void {
    if (this.canEmit && this._sortDirection !== SortDirection.NONE) {
      this.sortDirectionChange.emit(this._sortDirection);
    }
  }

  handleClick(): void {
    this.sortDirection = cycleDirection(this.sortDirection);
  }
}
